import { get as getPipe } from '../utils/sigpipe'
import { ACTIONS as MODAL_ACTIONS } from './modal'

export default {
  name: 'portrait-video-modal',

  ui: {
    overlay: '[js-portrait-video-modal-overflay]',
  },

  events: [
    {
      target: 'overlay',
      on: 'click',
      handle (e) {
        if (!this.lightYoutube) return
        if (this.player) {
          this.player.playVideo()
        } else {
          this.el.querySelector('.lty-playbtn').click()
          this.checkToSetupVideo()
        }
      },
    },
  ],

  componentDidMount () {
    this.timer = 0

    this.pipe = getPipe(this.el.parentNode.getAttribute('data-pipe-id'))
    this.pipe.on(({ action, emitterEl }) => {
      this.emitterEl = emitterEl
      switch (action) {
        case MODAL_ACTIONS.OPEN:
          // console.log('modalVideo open', this.pipe)
          break

        case MODAL_ACTIONS.CLOSE:
          if (this.player) {
            this.player.pauseVideo()
            // this.lightYoutube.classList.remove('lyt-activated')
          } else if (this.el.querySelector('[js-video-player-video]')) {
            this.el.querySelector('[js-video-player-video]').pause()
          }
          break
      }
    })

    this.lightYoutube = this.el.querySelector('.lite-youtube')
    if (this.lightYoutube) {
      /* window.onYouTubeIframeAPIReady = () => {
        console.log('onYouTubeIframeAPIReady')
        this.checkToSetupVideo()
      } */

      if (this.lightYoutube && typeof YT === 'undefined') {
        const tag = document.createElement('script')
        tag.src = 'https://www.youtube.com/iframe_api'
        // const firstScriptTag = document.getElementsByTagName('script')[0]
        // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
        document.querySelector('body').prepend(tag)
      }
    }
  },

  checkToSetupVideo () {
    if (this.el.querySelector('lite-youtube iframe')) {
      clearTimeout(this.timer)
      this.setUpYoutubePlayer()
    } else {
      this.timer = setTimeout(this.checkToSetupVideo, 500)
    }
    if (this.timer > 120) clearTimeout(this.timer)
  },

  setUpYoutubePlayer () {
    if (
      !this.player &&
      this.lightYoutube &&
      // this.lightYoutube.classList.contains('lyt-activated') &&
      typeof YT !== 'undefined'
    ) {
      this.player = new YT.Player(this.lightYoutube.querySelector('iframe'), {
        events: {
          onStateChange: (e) => {
            // console.log(e.data, YT.PlayerState)
            if (e.data === YT.PlayerState.PLAYING) {
              this.ui.overlay.classList.add('is-hidden')
            } else if (e.data === YT.PlayerState.PAUSED) {
              this.ui.overlay.classList.remove('is-hidden')
            } else if (e.data === YT.PlayerState.BUFFERING) {
              this.ui.overlay.classList.add('is-hidden')
            } else if (e.data === YT.PlayerState.ENDED) {
              if (!window.screenTop && !window.screenY) { // Browser is in fullscreen
                document.exitFullscreen()
              }
            }
          },
          /*  onPlayProgress: (e) => {
            console.log('onPlayProgress', this.player.getCurrentTime())
          }, */
        },
      },
      )
    }
  },
}
